// extracted by mini-css-extract-plugin
module.exports = {"splide_slidewrap":"GalleryCarousel_splide_slidewrap__zHpTC","splide-loading":"GalleryCarousel_splide-loading__K5TIk"};